<template>
  <div class="row">
    <div class="col">
      <div class="card bg-white">
        <div class="card-header bg-gray-100">
          <p class="text-semibold no-margin">
            Tipo de Serviço | {{id}}
          </p>
          <div class="heading-elements">
            <i class="fas fa-long-arrow-alt-left position-left" @click="voltar()" style="cursor: pointer"></i>
          </div>
        </div>

        <div class="box-body">
					<div v-show="errorMessage != ''" class="alert alert-danger">{{ errorMessage }}</div>

          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="descricao">Descrição <sup class="text-danger">* </sup></label>
              <input id="descricao" v-model="registro.descricao" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.descricao }">
              <span v-show="errors.descricao != null" class="help-inline">{{ errors.descricao }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="observacao">Observação <sup class="text-danger">* </sup></label>
              <input id="observacao" v-model="registro.observacao" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.observacao }">
              <span v-show="errors.observacao != null" class="help-inline">{{ errors.observacao }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="idc_status">Status <sup class="text-danger">* </sup></label>
              <select id="idc_status" v-model="registro.idc_status" style="width: auto" class="form-control" v-bind:class="{ 'box-input-required': errors.idc_status }">
                <option value="1">Ativo</option>
                <option value="2">Inativo</option>
              </select>
              <span v-show="errors.idc_status != null" class="help-inline">{{ errors.idc_status }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="idc_instalacao">Instalação <sup class="text-danger">* </sup></label>
              <select id="idc_instalacao" v-model="registro.idc_instalacao" style="width: auto" class="form-control" v-bind:class="{ 'box-input-required': errors.idc_instalacao }">
                <option value="1">Sim</option>
                <option value="2">Não</option>
              </select>
              <span v-show="errors.idc_instalacao != null" class="help-inline">{{ errors.idc_instalacao }}</span>
            </div>
          </div>
        </div>

        <div class="box-footer text-center">
          <div class="btn-group">
            <button type="button" id="cancelButton" class="btn btn-warning" @click="voltar()">Cancelar</button>
            <button type="button" id="gravarButton" class="btn btn-success" @click="gravar()">Gravar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Actions from '../../actions/ServicoTipoActions'

export default {
  name: 'editar',
  props: ['id'],
  data () {
    return {
      errorMessage: '',
      errors: {},
      hasError: false,
      registro: {
        descricao: '',
        observacao: '',
        idc_status: '',
        idc_instalacao: ''
      }
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = 'Editar'

    Actions.obterTipoServico(this.id)
      .then(res => {
        if (res && res.descricao) {
          this.registro = res
        } else {
          this.errorMessage = 'Registro não encontrado.'
        }
      })
      .catch((error) => {
        console.log(error.message)
        this.errorMessage = 'Registro não encontrado.'
      })
  },
  methods: {
    voltar () {
      this.$router.push('/servico-tipo')
    },
    validation () {
      this.errors = {}
      this.hasError = false

      if (!this.registro.descricao) {
        this.errors.descricao = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.observacao) {
        this.errors.observacao = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.idc_status) {
        this.errors.idc_status = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.idc_instalacao) {
        this.errors.idc_instalacao = 'Este campo deve ser preenchido.'
        this.hasError = true
      }
    },
    gravar () {
      this.validation()

      if (!this.hasError) {
        this.$parent.$parent.$data.showModalLoader = true

        Actions.alterarTipoServico({
          id: this.id,
          descricao: this.registro.descricao,
          observacao: this.registro.observacao,
          idc_status: this.registro.idc_status,
          idc_instalacao: this.registro.idc_instalacao
        })
        .then(response => {
          this.$parent.$parent.$data.showModalLoader = false
          this.$router.push('/servico-tipo')
        })
        .catch((error) => {
          console.log(error.message)
          this.errorMessage = 'Ocorreu um erro ao gravar o registro.'
          this.$parent.$parent.$data.showModalLoader = false
        })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/servico-tipo/Editar.vue